module.exports = __webpack_public_path__ + "static/media/sq_wahana.baea9e29.png";